import axios from "axios";
import router from '../../../router';

export default {

    async customers_search(context, payload){

        const token = context.rootGetters.token;
        console.log('request for customers');

        try{
            const responseData = await axios({
                method: 'post',
                url: process.env.VUE_APP_API_ENDPOINT+'customers_search',
                data: {
                    term: payload.term,
                    limit: payload.limit,
                    offset: payload.offset,
                    conn_id: payload.conn_id
                },
                mode: 'no-cors',
                headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization' : token
                }
            })

            if(!responseData.data.success){
                context.commit('setRequestError', {message:responseData.data.message} );
            } else {
                context.commit('setRequestError', {message:''} );
                context.commit('setCustomers', responseData.data.results);
            }

        } catch(error){
            console.log('error in request')
            context.dispatch('autoLogout', null, { root: true });
            router.replace('/login');
        }

    }

}